import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";

/**
 * PhotosApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/photosApi/photosApi.service.js.
 *
 * `upload()` posts to a hardcoded `/v1/api/photos/1` path (legacy quirk —
 * the trailing `/1` is preserved verbatim). Angular's HttpClient handles
 * FormData boundary headers automatically, so we don't set Content-Type.
 */
const PHOTOS_BASE = "/v1/api/photos";

@Injectable({ providedIn: "root" })
export class PhotosApiService {
  private readonly http = inject(HttpClient);

  remove(id: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.delete<unknown>(`${PHOTOS_BASE}/${id}`));
  }

  upload(props: { files: File[] }): Promise<AjsResponse<unknown>> {
    const data = new FormData();
    for (const file of props.files) {
      data.append("file", file);
    }
    return wrapAjs(this.http.post<unknown>(`${PHOTOS_BASE}/1`, data));
  }
}
